import styled, { css, keyframes } from "styled-components";

// const fadeInAnim = keyframes`
//   0%{
//      transform: translateY(75px);
//      opacity:0
//   }
//   10%{
//     transition-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
//     transform: translateY(75px);
//     opacity:0
//   }
//   50%{
//     transition-timing-function: cubic-bezier(0.29, 0.2, 0.62, 1);
//     transform:translateY(-10px);
//     opacity:0.5;
//   }
//   100%{
//     transform:translateY(0px)
//     opacity:1
//    } 
// `;

// const fadeOutAnim = keyframes`
//   0%{
//     transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
//      transform: translateY(0);
//      opacity:1;
//     }
//     100%{
//       transform:translateY(123px);
//       opacity:0;
//    } 
// `;

// const fadeIn = css`
//   ${fadeInAnim} 0.55s 1 forwards
// `;
// const fadeOut = css`
//   ${fadeOutAnim} 0.55s 1 forwards
// `;

// export const SetBetDiv = styled.div`
//   animation: ${fadeIn};
//   animation: ${(p) => (p.unBlur ? fadeOut : null)};

//   position: absolute;
//   top: 0;
//   left: 0;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background-color: #7f3da5;
//   width: 100%;
//   height: 100%;
//   opacity: 0.91;
// `;
export const SetBetBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 607px;
 `;
export const Text = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  font-size: 36px;
  font-weight: bold;
  font-style: normal;
  font-stretch: expanded;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffb000;
  max-width: 320px;
  margin-bottom: 80px;
  input {
    text-align: center;
    width: 100%;
    background: transparent;
    border: none;
    font-size: 23px;
    color: #ffb000;
  }
`;
export const Ops = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  max-width: 320px;
  height: 19%;
  padding-bottom: 20px;
`;

const scaleAnimFooterBtn = keyframes`
  0%{  
    animation-timing-function: cubic-bezier(.33,1,0,1);
    transform: scale(1);
    }
  50%{
    animation-timing-function: cubic-bezier(0,0,0,1);
    transform: scale(.65);

   }
  100%{
    transform: scale(1); 
    } 
`;
const animFooterBtn = css`
  ${scaleAnimFooterBtn} 0.33s 1 forwards
`;
const whiteDivOpa1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,.2,1);
    opacity: 0;
     }
  33%{
    animation-timing-function: cubic-bezier(1.5,3.6,.2,1);
     opacity: 0.5;
    }
  100%{
     opacity:0;
  } 
`;
const whiteDivOpa = css`
  ${whiteDivOpa1} 0.33s 1 forwards
`;
export const Opr = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  background-color: #ffb000;
  border-radius: 28px;
  color: #ff3920;
  font-size: 20px;
  cursor: pointer;

  animation: ${(p) => (p.anim ? animFooterBtn : null)};
  ${(p) =>
    p.plusPress || p.minusPress
      ? "transform: scale(0.65); transition-timing-function: cubic-bezier(0.33, 1, 0, 0); transition: transform 0.33s;"
      : "transform: scale(1); transition-timing-function: cubic-bezier(0.1, 0, 0, 1); transition: transform 0.33s;"}

  .white {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;
    animation: ${(p) => (p.anim ? whiteDivOpa : null)};
    ${(p) =>
      p.plusPress || p.minusPress
        ? "opacity: 0.5; transition-timing-function: cubic-bezier(0.33, 1, 0, 0); transition: transform 0.33s;"
        : "opacity: 0; transition-timing-function: cubic-bezier(0.1, 0, 0, 1); transition: transform 0.33s;"}
  }
`;
const playUnpressAnim = keyframes`
  0%{
    transform: scale(.8)
    transition-timing-function: cubic-bezier(0,0,.2,.93);
    box-shadow: 0 0 0 0 rgba(50, 7, 91, 0.5);

   }
  50%{
    transition-timing-function: cubic-bezier(.31,-0.17,.67,1.21);
    transform: scale(1.05);

   }
  100%{
    box-shadow: 0 15px 10px 0 rgba(50, 7, 91, 0.5);

    transform: scale(1);
   } 
`;
const playUnPress = css`
  ${playUnpressAnim} 0.2s 1 forwards
`;
export const SetBetBtn = styled.div`
  position: relative;
  width: 100%;
  max-width: 320px;
  font-size: 20px;
  border-radius: 30px;
  background-color: #ffb000;
  color: #ff3920;
  text-align: center;
  padding: 15px 0 17px;
  animation: ${(p) => (p.playUnpress ? playUnPress : null)};
  pointer-events: ${(p) => (p.playPress ? "none" : "auto")};
  cursor: pointer;
  ${(p) =>
    p.playPress
      ? "transform: scale(0.8);transition-timing-function: cubic-bezier(.29,.16,.29,1.23); transition: transform 0.1s;"
      : "transform: scale(1); transition-timing-function: cubic-bezier(0.1, 0, 0, 1); transition: transform 0.1s;"};
  .white {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    border-radius: 50px;
    background: #ffffff;
    opacity: 0;
    animation: ${(p) => (p.playPress ? whiteDivOpa : null)};
  }
  /* @media only screen and (max-width: 374px) {
    padding: 12px 0 10px;
    font-size: 18px;
  } */
`;
export const BackBtn = styled.div`
  color: #ffb000;
  font-size: 20px;
  text-align: center;
  width: 100%;
  max-width: 320px;
  margin-top: 24px;
  cursor: pointer;

  /* @media only screen and (max-width: 374px) {
    font-size: 18px;
  } */
`;
